import { getCurrentVersion } from "../dataLayer/getDataSources";

export async function currentSBVersion() {
  const tempJson = await getCurrentVersion();
  return tempJson?.space?.version;
}
